import { render } from "./SidebarToggle.vue?vue&type=template&id=1ac7ad9d&ts=true"
import script from "./SidebarToggle.vue?vue&type=script&lang=ts"
export * from "./SidebarToggle.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/SidebarToggle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ac7ad9d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ac7ad9d', __exports__)) {
    api.reload('1ac7ad9d', __exports__)
  }
  
  module.hot.accept("./SidebarToggle.vue?vue&type=template&id=1ac7ad9d&ts=true", () => {
    api.rerender('1ac7ad9d', render)
  })

}


export default __exports__